import { createContext, useContext, ReactNode } from 'react';
import type { LocaleCode } from '@/types/locale';

interface LocaleContextType {
  locale: LocaleCode;
  setLocale: (locale: LocaleCode) => void;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

interface LocaleProviderProps {
  children: ReactNode;
  initialLocale?: LocaleCode;
}

export function LocaleProvider({ children, initialLocale = 'en-GB' }: LocaleProviderProps) {
  // For now, we'll just use a static locale
  // In the future, this could be expanded to include locale switching functionality
  const value = {
    locale: initialLocale,
    setLocale: () => {}, // Placeholder for future implementation
  };

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const context = useContext(LocaleContext);
  if (context === undefined) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
}
